/* Creative Objekt — mega menu behaviour: one panel open at a time, hover-open on mouse,
   close on outside click / Escape / link click. Works without JS as plain <details>. */
(() => {
  const items = () => [...document.querySelectorAll('[data-co-mega]')];
  const closeAll = (except) => items().forEach((d) => { if (d !== except) d.removeAttribute('open'); });
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const init = () => {
    items().forEach((item) => {
      let timer;
      item.addEventListener('toggle', () => { if (item.open) closeAll(item); });
      item.addEventListener('click', (event) => { if (event.target.closest('a')) closeAll(); });
      item.addEventListener('mouseenter', () => {
        if (!finePointer.matches) return;
        window.clearTimeout(timer);
        item.setAttribute('open', '');
      });
      item.addEventListener('mouseleave', () => {
        if (!finePointer.matches) return;
        timer = window.setTimeout(() => item.removeAttribute('open'), 160);
      });
    });
    document.addEventListener('click', (event) => { if (!event.target.closest('[data-co-mega]')) closeAll(); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = items().find((d) => d.open);
      if (open) { open.removeAttribute('open'); open.querySelector('summary')?.focus(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Old "?department=" links (bookmarks, ads, the previous homepage) go to the new pages. */
(() => {
  const params = new URLSearchParams(window.location.search);
  const dept = params.get('department');
  if (!dept || !window.location.pathname.startsWith('/collections')) return;
  const map = {
    retail: '/collections/all/business-retail-display',
    brand: '/collections/all/business-corporate-gifting',
    workplace: '/collections/all/room-home-office',
    home: '/collections/all',
    all: '/collections/all'
  };
  window.location.replace(map[dept] || '/collections/all');
})();
